import { useEffect } from 'react';
import { useParams, useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const supportedLngs = ['en', 'fr'];

const LanguageWrapper = ({ children }) => {
  const { lang } = useParams();
  const { i18n } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (lang && supportedLngs.includes(lang) && i18n.language !== lang) {
      i18n.changeLanguage(lang);
    } else if (!lang) {
      // If no lang in URL, redirect to the one from i18next
      const newPath = `/${i18n.language}${location.pathname}`;
      navigate(newPath, { replace: true });
    }
  }, [lang, i18n, navigate, location.pathname]);

  return children;
};

export default LanguageWrapper;
